exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".check-off-history-item {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.1);\n  padding: 4px 8px;\n  margin-bottom: 4px;\n}\n.completed-date {\n  font-size: 0.8em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/checkoffs/check-off-history-item/check-off-history-item.component.less
// module id = ./src/app/checkoffs/check-off-history-item/check-off-history-item.component.less
// module chunks = 0